<template>
  <div class="control">
    <Loader v-if="soft_loading" :soft="true" />
    <InputRow label="Ai Product Description">
        <textarea v-model="ai_product_description" rows="20" cols="50">
        </textarea>
    </InputRow>
    <InputRow label="Ai Product Description (JSON)">
        <textarea v-model="ai_product_description_2" rows="20" cols="50">
        </textarea>
    </InputRow>
    <InputRow label="">
      <button class="margin-right" @click="update()">Update</button>
      <button class="margin-right" @click="request()">Request creation</button>
    </InputRow>
  </div>
</template>
<script>
  import Vue from 'vue'

  export default {
    props: [
      'product_id'
    ],
    data: () => ({
      ai_product_description: '',
      ai_product_description_2: null,
      soft_loading: false
    }),
    methods: {
      getId () {
        return this.product_id
      },
      update() {
        Vue.api.post('/ai/product/' + this.getId() + '/description', {
          description: this.ai_product_description,
          description_2: this.ai_product_description_2
        }, {
          before: () => this.soft_loading = true,
          always: () => this.soft_loading = false,
          callback: () => alert('Updated')
        })
      },
      request() {
        Vue.api.post('/ai/product/' + this.getId() + '/request-generation', {}, {
          before: () => this.soft_loading = true,
          always: () => this.soft_loading = false,
          callback: () => alert('Requested')
        })
      }
    },
    created () {
      if (this.getId() === null) {
        return;
      }
      Vue.api.get('/ai/product/' + this.getId() + '/description', {}, {
        callback: data => {
          this.ai_product_description = data.description
          this.ai_product_description_2 = data.description_2
        }
      })
    }
  }
</script>


<style scoped>

</style>
